import React from 'react';
import { Navigate } from 'react-router-dom';
import { useDataContext } from '../data/DataContext';

interface ProtectedRouteProps {
    children: React.ReactElement;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { isAdmin } = useDataContext();
    return isAdmin ? children : <Navigate to="/trips" />;
};

export default ProtectedRoute;